<template>
  <div>
    <div v-if="isLoading">
      <div class="text-center">Please wait getting data</div>
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </div>

    <v-data-table
      v-else
      :headers="headers"
      :items="category.InvoiceDetailType.InvoiceDetails"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr data-cy="customerListRows" class="pointer">
          <td class="report-td text-xs-left">{{ props.item.name }}</td>
          <td class="report-td text-xs-left">
            {{ parseInt(props.item.quantity) }}
          </td>
          <td class="report-td text-right">
            {{ props.item.subTotal | currency }}
          </td>
          <td class="report-td text-right">
            {{ props.item.cost | currency }}
          </td>
          <td class="report-td text-right">
            {{ (props.item.subTotal - props.item.cost) | currency }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import reportService from '@/modules/Invoice/service.js';
import reportService from "@/modules/Reports/service.js";

export default {
  name: "category-report",
  props: ["props", "date", "LocationId"],
  data() {
    return {
      category: [],
      headers: [
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("labels.quantity"),
          align: "left",
          value: "quantity",
          sortable: false,
        },
        {
          text: this.$t("labels.revenue"),
          align: "right",
          value: "revenue",
          sortable: false,
        },

        {
          text: this.$t("labels.cost"),
          align: "right",
          value: "cost",
          sortable: false,
        },
        {
          text: this.$t("labels.profit"),
          align: "right",
          value: "profit",
          sortable: false,
        },
      ],
      isLoading: true,
      selectedRange: null,
      dateTime: {
        start: this.$moment().startOf("month").toISOString(),
        end: this.$moment().endOf("month").toISOString(),
      },
    };
  },
  mounted() {
    if (this.date) {
      // console.log('getting date time as params from previous component', this.date)
      this.dateTime.start = this.date.start;
      this.dateTime.end = this.date.end;
      this.getList();
    } else {
      const { start, end, range } = this.$route.query;
      // console.log('this.$route.query', this.$route.query)
      this.dateTime.start = start;
      this.dateTime.end = end;
      this.selectedRange = range;
      this.getList();
    }
  },
  methods: {
    getList() {
      // console.log('prop', this.props);
      this.isLoading = true;
      const where = {
        LocationId: this.LocationId,
        start: this.dateTime.start,
        end: this.dateTime.end,
        InvoiceDetailTypeId: this.props.item.id,
      };
      return reportService.getProfitAndLoss(where).then((response) => {
        // console.log('response.data;', response.data);
        this.category = response.data;
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped></style>
